import { apiClientWithMiddleware } from '../utils/API';
const getPinnedAccountsEndpoint = '/accounts/v1/basic-accounts/pinned';
const isRequestError = json => {
  return typeof json === 'object' && 'message' in json;
};
const isImpersonating = error => {
  if (!isRequestError(error.responseJSON)) {
    return;
  }
  return error.responseJSON.message === "Can't use this feature while impersonating another user";
};
export const getAccounts = portalId => {
  return apiClientWithMiddleware().get(getPinnedAccountsEndpoint, {
    query: {
      portalId
    }
  }).then(response => Object.assign({}, response, {
    isImpersonating: false
  })).catch(error => {
    if (isImpersonating(error)) {
      return {
        basicAccounts: [],
        pinnedAccountIds: [],
        isImpersonating: true
      };
    }
    throw error;
  });
};